/*
 * Copyright (c) 2022. 42 bv (www.42.nl). All rights reserved.
 */
"use strict";

/**
 * @ngdoc function
 * @name diceApp.component:diceMemberBulkChange
 */
angular.module("diceApp").component("diceMemberBulkChange", {
  bindings: {
    type: "<",
    evaluations: "<",
    onChange: "&",
    onCancel: "&"
  },
  templateUrl: "es6/evaluations/bulk/member.bulk.change.html",
  controllerAs: "memberBulkChangeController",
  controller: function (
    Evaluation,
    MemberType,
    descriptionFilter,
    message,
    translateFilter,
    language
  ) {
    const memberBulkChangeController = this;

    memberBulkChangeController.$onInit = function () {
      memberBulkChangeController.onLanguage = language.onChange(setActions);

      loadData();
      setActions();
    };

    function setActions() {
      memberBulkChangeController.actions = [
        {
          bulkAction: "ADD",
          label: translateFilter("Page.EvaluationList.BulkChange.Action.Add"),
          description: translateFilter(
            "Page.EvaluationList.BulkChange.AddMember.Description"
          )
        },
        {
          bulkAction: "OVERRIDE",
          label: translateFilter(
            "Page.EvaluationList.BulkChange.Action.Override"
          ),
          description: translateFilter(
            "Page.EvaluationList.BulkChange.OverrideMember.Description"
          )
        },
        {
          bulkAction: "DELETE",
          label: translateFilter(
            "Page.EvaluationList.BulkChange.Action.Delete"
          ),
          description: translateFilter(
            "Page.EvaluationList.BulkChange.DeleteMember.Description"
          )
        }
      ];
    }

    memberBulkChangeController.$onDestroy = function () {
      memberBulkChangeController.onLanguage();
    };

    function loadData() {
      MemberType.query({
        evaluationType: memberBulkChangeController.type.id
      }).$promise.then((memberTypes) => {
        memberBulkChangeController.memberTypes = _(memberTypes)
          .filter({ editable: true })
          .map((memberType) => {
            const label = descriptionFilter(memberType.names);
            return _.extend(memberType, { label });
          })
          .sortBy(["label", "id"])
          .value();
      });
    }

    memberBulkChangeController.save = function () {
      Evaluation.bulkMember({
        action: memberBulkChangeController.action.bulkAction,
        evaluationIds: _.map(memberBulkChangeController.evaluations, "id"),
        typeId: memberBulkChangeController.memberTypeId,
        personId: memberBulkChangeController.personId,
        deleteRemaining: memberBulkChangeController.action.deleteRemaining
      }).$promise.then((result) => {
        message.addInfoLabel("Message.Save.Success");
        memberBulkChangeController.onChange({ result });
      });
    };
  }
});
